export const translateMessage = (data) => {
  return {
    data,
    type: 'transform:translate',
  }
}

export const setMessage = (data) => {
  return {
    data,
    type: 'transform:set',
  }
}

export const viewportMessage = (data) => {
  return {
    data,
    type: 'transform:viewport',
  }
}
